import React from 'react'

const PowersportNotFitIcon = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="27" height="27" rx="13.5" fill="#CC3333" />
    <path d="M20.5 7.91L19.09 6.5L13.5 12.09L7.91 6.5L6.5 7.91L12.09 13.5L6.5 19.09L7.91 20.5L13.5 14.91L19.09 20.5L20.5 19.09L14.91 13.5L20.5 7.91Z" fill="white" />
  </svg>
)

export default PowersportNotFitIcon
